<ng-container *ngIf="!isLoadingTags && !isLoadingLabels">
	<div class="title" *ngIf="!hideTitle">{{ labels.lbl_tags_arvore_conhecimento }}</div>

	<div class="navigation">
		<span
			*ngFor="let selectedTag of selectedTags; let tagColIndex = index"
			(click)="selectedTags[tagColIndex + 1] != undefined ? rollbackTo(tagColIndex + 1, true, true) : null"
			>< {{ labels[selectedTag[userLanguage]] ? labels[selectedTag[userLanguage]] : selectedTag[userLanguage] }}</span
		>
	</div>

	<div class="knowledge-management-tags-container">
		<div
			class="tag-col"
			[ngClass]="{ hide: shownTags.length > 3 && tagColIndex < shownTags.length - 3 }"
			*ngFor="let tagCol of shownTags; let tagColIndex = index">
			<div
				class="tag"
				[ngClass]="{ selected: tag.selected, 'last-selected': selectOnlyLast && tag.lastSelected }"
				[title]="labels[tag[userLanguage]] ? labels[tag[userLanguage]] : tag[userLanguage]"
				*ngFor="let tag of tagCol">
				<span (click)="tag.selected != true ? expandTag(tag, tagColIndex) : rollbackTo(tagColIndex, true, true)">{{
					labels[tag[userLanguage]] ? labels[tag[userLanguage]] : tag[userLanguage]
				}}</span>
				<span class="tag-option" (click)="openRegister(tagColIndex, tag)" *ngIf="canEdit && tag.customer_id !== '' && tag.selected"
					><fa-icon [icon]="icons.faPen"></fa-icon
				></span>
			</div>
			<div class="tag end" (click)="openRegister(tagColIndex, null)" *ngIf="canAdd">
				<span><fa-icon [icon]="icons.faPlus"></fa-icon></span>
			</div>
		</div>
		<div class="loading-tag-col" *ngIf="isLoadingNextLevel">
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>

	<div class="register-container" [ngClass]="{ open: isRegisterOpen }">
		<div class="header">
			<span (click)="cleanRegister(); isRegisterOpen = false"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
		</div>
		<cpi-generic-form-gen
			[labels]="labels"
			[setGenericForm]="registerForm"
			[triggerRequired]="triggerAreRequiredFulfilled"
			(getGenericForm)="registerForm = $event"
			(getFieldDictionary)="registerFormDictionary = $event">
		</cpi-generic-form-gen>
		<div class="button-container">
			<div
				class="button"
				[ngClass]="{ disabled: isLoadingRegister }"
				(click)="addTag()"
				*ngIf="!registerFormDictionary['id'].values[0] || registerFormDictionary['id'].values[0] == '-1'">
				{{ labels.lbl_criar_novo_item }}
			</div>
			<div
				class="button"
				[ngClass]="{ disabled: isLoadingRegister }"
				(click)="deleteTag()"
				*ngIf="registerFormDictionary['id'].values[0] && registerFormDictionary['id'].values[0] != '-1'">
				{{ labels.lbl_geral_excluir }}
			</div>
			<div
				class="button"
				[ngClass]="{ disabled: isLoadingRegister }"
				(click)="updateTag()"
				*ngIf="registerFormDictionary['id'].values[0] && registerFormDictionary['id'].values[0] != '-1'">
				{{ labels.lbl_geral_atualizar }}
			</div>
		</div>
	</div>
</ng-container>

<div class="loading-tag-col" *ngIf="isLoadingTags">
	<div></div>
	<div></div>
	<div></div>
</div>
